// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import ConnectedFlagsProvider from '../redux/flags/ConnectedFlagsProvider';
import AdWrapper from '@wix/da-ads/pkg/AdWrapper';
import 'focus-visible';
import isServerSideRendering from '../utils/isSSR';
const DaAppWrapper = ({ store, children, headTags, DaAds })=>{
    let content = children;
    const isSSR = isServerSideRendering();
    const isDebug = !isSSR && window['reduxdebug'];
    const reduxStabilityCheck = !isSSR && isDebug ? 'always' : 'never';
    if (process.env.NODE_ENV !== 'production') {
        content = /*#__PURE__*/ React.createElement(Flag, {
            condition: "strictmode",
            render: ()=>/*#__PURE__*/ React.createElement(React.StrictMode, null, children),
            fallbackRender: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, children)
        });
    }
    return /*#__PURE__*/ React.createElement(HelmetProvider, {
        context: headTags
    }, /*#__PURE__*/ React.createElement(AdWrapper, {
        DaAds: DaAds
    }, /*#__PURE__*/ React.createElement(Provider, {
        store: store,
        stabilityCheck: reduxStabilityCheck
    }, /*#__PURE__*/ React.createElement(ConnectedFlagsProvider, null, content))));
};
DaAppWrapper.displayName = 'DaAppWrapper';
export default DaAppWrapper;
